import { render, staticRenderFns } from "./SubmitReturnSuccess.vue?vue&type=template&id=6e57fa80&scoped=true"
import script from "./SubmitReturnSuccess.vue?vue&type=script&lang=ts"
export * from "./SubmitReturnSuccess.vue?vue&type=script&lang=ts"
import style0 from "./SubmitReturnSuccess.vue?vue&type=style&index=0&id=6e57fa80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57fa80",
  null
  
)

export default component.exports